module.exports = __webpack_public_path__ + "static/media/U1-T2-1-3.d84451df.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/U1-T2-1-3.mp3
// module id = 524
// module chunks = 0